import React, { lazy } from 'react';

const SubcontractorLoginComponent = lazy(
  () =>
    import(
      '../SubcontractorManagement/SubcontractorLogin/SubcontractorLogin.page'
    )
);
const SubcontractorManagementHome = lazy(
  () =>
    import(
      '../SubcontractorManagement/SubcontractorHome/SubcontractorHome.page'
    )
);

export const subcontractorRoutes = [
  { path: '', element: <SubcontractorManagementHome /> },
  { path: 'login', element: <SubcontractorLoginComponent /> },
];
